<mat-menu #userMenu [xPosition]="'before'" class="download-menu-dropdown mat-menu-panel mat-elevation-z4 mat-menu-content menu-unlimited-width menu-no-padding">
      <div class="flex flex-row selection-search mt-36 ml-16">
        <select class="fw-500 form-select selection" [(ngModel)]="selected" (ngModelChange)="getSelected($event)" (click)="$event.stopPropagation()">
            <ng-container *ngFor="let search of searchOptions">
              <option class="selection-option"[ngValue]="search.value" *ngIf="search.value">{{ search.value }}</option>
            </ng-container>
        </select>
        <div class="flex flex-row justify-between items-center search-container" (click)="$event.stopPropagation()">
          <input class="search-container fw-400 h-34 no-border" [placeholder]="searchPlaceholder" [(ngModel)]="searchValue"
                 type="text" #searchInput>
          <mat-icon [ngClass]="{'disabled': !searchValue}" class="mr-16 icon-lg icon-color cursor-pointer" svgIcon="search" (click)="searchBlueprint()"></mat-icon>
        </div>
      </div>
      <div class="flex flex-row justify-between m-16" (click)="$event.stopPropagation()">
        <div *ngIf="searchText">{{'GLOBAL_SEARCH.SHOWING_RESULTS_FOR' | transloco}}
          <span class="fw-500">{{searchText}}</span>
        </div>
        <div *ngIf="searchText" class="selected-color cursor-pointer fw-700 fs-12" (click)="clearInput()">{{'GLOBAL_SEARCH.CLEAR' | transloco}}</div>
      </div>
      <div class="table-scroll">
        <div (click)="openUrl(data)" *ngFor="let data of dataSource; let i = index" class="ml-16 mr-16 cursor-pointer">
          {{((selected === 'Instance Name' || selected === 'Instance Suffix') && data.randomSuffix) ? data.name + '('+ data.randomSuffix +')' : data.name}}
          <mat-divider *ngIf="i < dataSource.length - 1" class="dropdown-divider mt-8 mb-16"></mat-divider>
        </div>
      </div>
      <ng-container *ngIf="dataSource && !showData">
          <span class="flex justify-center mt-100 no-results">{{'GLOBAL_SEARCH.NO_RESULTS' | transloco}}</span>
      </ng-container>
  </mat-menu>
  <div class="flex flex-row justify-center items-center border-left">
    <button [matMenuTriggerFor]="userMenu" mat-button class="account-color">
        <mat-icon class="icon-lg cursor-pointer" svgIcon="search"></mat-icon>
    </button>
  </div>  